import { Controller } from '@hotwired/stimulus'
import { createPopper } from '@popperjs/core'

// Flowbite Tooltip (triggerType: 'click') 相当の挙動を Popper.js で再現する。
export default class extends Controller {
  static targets = ['trigger', 'content']
  static values = { placement: { type: String, default: 'top' } }

  connect() {
    this.popperInstance = createPopper(this.triggerTarget, this.contentTarget, {
      placement: this.placementValue,
      modifiers: [this.offsetModifier, { name: 'eventListeners', enabled: false }],
    })

    this.onClickOutside = this.onClickOutside.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
  }

  get offsetModifier() {
    return { name: 'offset', options: { offset: [0, 8] } }
  }

  disconnect() {
    this.hide()
    if (this.popperInstance) {
      this.popperInstance.destroy()
      this.popperInstance = null
    }
  }

  toggle() {
    if (this.visible) {
      this.hide()
    } else {
      this.show()
    }
  }

  show() {
    if (this.visible) return

    this.contentTarget.classList.remove('opacity-0', 'invisible')
    this.contentTarget.classList.add('opacity-100', 'visible')
    this.visible = true

    this.popperInstance.setOptions({
      modifiers: [this.offsetModifier, { name: 'eventListeners', enabled: true }],
    })
    this.popperInstance.update()

    document.addEventListener('click', this.onClickOutside, true)
    document.addEventListener('keydown', this.onKeydown)
  }

  hide() {
    if (!this.visible) return

    this.contentTarget.classList.remove('opacity-100', 'visible')
    this.contentTarget.classList.add('opacity-0', 'invisible')
    this.visible = false

    this.popperInstance.setOptions({
      modifiers: [this.offsetModifier, { name: 'eventListeners', enabled: false }],
    })

    document.removeEventListener('click', this.onClickOutside, true)
    document.removeEventListener('keydown', this.onKeydown)
  }

  onClickOutside(event) {
    if (this.contentTarget.contains(event.target) || this.triggerTarget.contains(event.target)) {
      return
    }
    this.hide()
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.hide()
    }
  }
}
